import { isIPad, isIPhone } from '../../../../jira-common/utils/native/detectDeviceType';
export const getDropDownMenuPosition = () => isIPhone() || isIPad() ?
// This is to prevent menu floating away due to virtual keyboard in iPad and iPhone
{
  menuPosition: 'absolute'
} :
// This is to prevent long menu getting cut off in portal
{
  menuPosition: 'fixed'
};